<template>
  <div>
    <van-skeleton title :row="14" />
  </div>
</template>

<script>
import { Toast, Skeleton } from 'vant'
import { getNewsPath } from '@/api/auth/auth.js'
export default {
  name: 'HomeIndex',
  components: {
    [Toast.name]: Toast,
    [Skeleton.name]: Skeleton
  },
  data() {
    return {
      routerList: []
    }
  },
  async mounted() {
    this.init()
    if (this.$route.query.messageLogId) {
      await this.toNewsDetail(this.$route.query.messageLogId)
    } else {
      this.$router.push({
        path: '/home'
      })
    }
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = 'tryine-创研智能数字化系统'
    },
    async toNewsDetail(messageLogId) {
      const that = this
      await getNewsPath(messageLogId).then(res => {
        if (res.code === 200) {
          setTimeout(() => {
            that.$router.push({
              path: res.msg
            })
          }, 500)
        } else {
          Toast.fail(res.msg)
          setTimeout(() => {
            that.$router.push({
              path: '/home'
            })
          }, 500)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

</style>
